exports = module.exports = require("../../../../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".v-textarea textarea{-ms-flex-item-align:stretch;align-self:stretch;-webkit-box-flex:1;-ms-flex:1 1 auto;flex:1 1 auto;line-height:1.75rem;max-width:100%;min-height:32px;outline:none;padding:0;width:100%}", ""]);

// exports
